import React from 'react';

// Fondo general con el mismo lenguaje visual de la cinta del sidebar: hojas de
// seda translucidas que nacen de un canto brillante y se desvanecen, sobre un
// fondo oscuro morado. Es vectorial y estatico (sin animacion): los cantos
// quedan nitidos a cualquier densidad de pixeles y el desenfoque solo vive en
// las hojas, donde se quiere suave.

function Ribbon({ id, edge, sheet, fold, gradient, glow = '#c084fc', edgeWidth = 2.2 }) {
  return (
    <g>
      <defs>
        <linearGradient id={`${id}-sheet`} {...gradient}>
          <stop offset="0" stopColor="#c084fc" stopOpacity="0.85" />
          <stop offset="0.5" stopColor="#7c3aed" stopOpacity="0.42" />
          <stop offset="1" stopColor="#5b21b6" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={`${id}-edge`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#f5d0fe" stopOpacity="0.95" />
          <stop offset="0.5" stopColor="#c4b5fd" stopOpacity="0.85" />
          <stop offset="1" stopColor="#a78bfa" stopOpacity="0.1" />
        </linearGradient>
      </defs>
      <path d={sheet} fill={`url(#${id}-sheet)`} filter="url(#wizBgSoft)" />
      <path d={sheet} fill={`url(#${id}-sheet)`} fillOpacity="0.5" />
      {fold && <path d={fold} fill="none" stroke="#c4b5fd" strokeOpacity="0.28" strokeWidth="1.2" />}
      <path d={edge} fill="none" stroke={glow} strokeOpacity="0.55" strokeWidth="10" filter="url(#wizBgGlow)" />
      <path d={edge} fill="none" stroke={`url(#${id}-edge)`} strokeWidth={edgeWidth} />
    </g>
  );
}

export default function WizardBackdrop() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden bg-[#06030d]">
      {/* En pantallas angostas el SVG conserva su proporcion y se ancla a la
          derecha, donde estan las hojas; en desktop cubre todo el fondo. */}
      <svg
        className="absolute right-0 top-0 h-full w-auto max-w-none lg:inset-0 lg:w-full"
        viewBox="0 0 1600 1000"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <linearGradient id="wizBgBase" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#07040f" />
            <stop offset="1" stopColor="#0d0620" />
          </linearGradient>
          <radialGradient id="wizBgGlowTR" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0" stopColor="#8b5cf6" stopOpacity="0.5" />
            <stop offset="1" stopColor="#8b5cf6" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="wizBgGlowBL" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0" stopColor="#a855f7" stopOpacity="0.5" />
            <stop offset="1" stopColor="#a855f7" stopOpacity="0" />
          </radialGradient>
          <filter id="wizBgSoft" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="16" />
          </filter>
          <filter id="wizBgGlow" x="-10%" y="-10%" width="120%" height="120%">
            <feGaussianBlur stdDeviation="5" />
          </filter>
        </defs>

        <rect width="1600" height="1000" fill="url(#wizBgBase)" />
        <circle cx="1400" cy="80" r="520" fill="url(#wizBgGlowTR)" />
        <circle cx="120" cy="900" r="520" fill="url(#wizBgGlowBL)" />

        {/* Superior derecha: la hoja cae desde arriba hacia el borde derecho */}
        <Ribbon
          id="wizR1"
          edge="M840 -10 C930 130 1120 190 1300 170 C1450 154 1560 200 1640 260"
          sheet="M840 -10 C930 130 1120 190 1300 170 C1450 154 1560 200 1640 260 L1640 -10 Z"
          fold="M900 -10 C990 100 1140 150 1300 128 C1440 110 1550 140 1640 190"
          gradient={{ x1: 0, y1: 1, x2: 1, y2: 0 }}
        />
        <Ribbon
          id="wizR1b"
          edge="M1010 -10 C1080 60 1200 90 1330 70 C1440 54 1540 70 1640 110"
          sheet="M1010 -10 C1080 60 1200 90 1330 70 C1440 54 1540 70 1640 110 L1640 -10 Z"
          gradient={{ x1: 0, y1: 1, x2: 1, y2: 0 }}
          edgeWidth={1.6}
        />

        {/* Izquierda: sube desde la esquina inferior */}
        <Ribbon
          id="wizR2"
          edge="M-20 540 C110 522 250 590 370 690 C470 772 610 826 780 830"
          sheet="M-20 540 C110 522 250 590 370 690 C470 772 610 826 780 830 C880 834 960 896 1010 1030 L-20 1030 Z"
          fold="M-20 640 C100 640 220 700 320 780 C400 846 500 900 620 920"
          gradient={{ x1: 1, y1: 0, x2: 0, y2: 1 }}
        />

        {/* Inferior derecha: dos hojas paralelas */}
        <Ribbon
          id="wizR3"
          edge="M1640 620 C1500 690 1350 850 1170 1010"
          sheet="M1640 620 C1500 690 1350 850 1170 1010 L1640 1010 Z"
          gradient={{ x1: 0, y1: 0, x2: 1, y2: 1 }}
        />
        <Ribbon
          id="wizR3b"
          edge="M1640 730 C1540 786 1430 900 1300 1010"
          sheet="M1640 730 C1540 786 1430 900 1300 1010 L1640 1010 Z"
          gradient={{ x1: 0, y1: 0, x2: 1, y2: 1 }}
          edgeWidth={1.6}
        />
      </svg>
    </div>
  );
}
